export const globalToastKey = 'global-toast-key';
export const globalErrorLostConnectionToastKey = 'global-error-lost-connection-toast-key';
